import Page from "../../page";
import ClientList from "../../../components/client-config/client-list";

const ClientConfigPage = () => {
  return (
    <Page>
      <ClientList />
    </Page>
  );
};

export default ClientConfigPage;
